var _desc, _defs, _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#394D65",
    fillOpacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 102",
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#FFFFFF",
    strokeOpacity: 0,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 336",
    d: "M42.19 28.41L32.11 28.41L32.11 18.33C32.11 17.32 31.44 16.65 30.43 16.65C29.42 16.65 28.75 17.32 28.75 18.33L28.75 28.41L18.67 28.41C17.67 28.41 17 29.08 17 30.09C17 31.1 17.67 31.77 18.67 31.77L28.75 31.77L28.75 41.85C28.75 42.85 29.42 43.52 30.43 43.52C31.44 43.52 32.11 42.85 32.11 41.85L32.11 31.77L42.19 31.77C43.2 31.77 43.87 31.1 43.87 30.09C43.87 29.08 43.2 28.41 42.19 28.41Z",
    fill: "#1F2D3D",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 336",
    d: "M32.11 28.41L32.11 18.33C32.11 17.32 31.44 16.65 30.43 16.65C29.42 16.65 28.75 17.32 28.75 18.33L28.75 28.41L18.67 28.41C17.67 28.41 17 29.08 17 30.09C17 31.1 17.67 31.77 18.67 31.77L28.75 31.77L28.75 41.85C28.75 42.85 29.42 43.52 30.43 43.52C31.44 43.52 32.11 42.85 32.11 41.85L32.11 31.77L42.19 31.77C43.2 31.77 43.87 31.1 43.87 30.09C43.87 29.08 43.2 28.41 42.19 28.41L32.11 28.41Z",
    stroke: "#707070",
    strokeOpacity: 0,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/add_new.7db0f6ab3358bfd1cba07ba7829ae357.svg";
export { ForwardRef as ReactComponent };